import Link from '@material-ui/core/Link';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { createLink, openInNewTab } from '../../../helpers/helperFunctions';
import { config } from '../models/Config';
import Version from './Version';

const useStyles = makeStyles((theme: Theme) => createStyles({
  footer: {
    marginTop: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    padding: 20,
    minHeight: 100,
    maxHeight: 100,
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      minHeight: 80
    }
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    height: 120
  },
  imgInnerCircle: {
    height: '35%',
    margin: '0 20px'
  },
  imgBadge: {
    height: '65%',
    margin: '0 20px'
  },
  imgPartner: {
    height: '55%',
    margin: '0 20px'
  },
  text: {
    display: 'flex',
    fontSize: '0.8em',
    color: 'white'
  },
  link: {
    color: '#f0ffff',    
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underLine',
    }
  }
}));

export default () => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.footer}>
      <div className={classes.row}>
        <Version />
      </div>
      <div className={classes.row}>
        {config.privacyLink ?
          <a className={classes.link} onClick={() => openInNewTab(config.privacyLink || '')} >
            <Typography className={classes.text}>{t('Terms of Use')}</Typography>
          </a> :
          <Link component={createLink('/privacy-policy')}>
            <Typography className={classes.text}>{t('Terms of Use')}</Typography>
          </Link>}
      </div>
      <Typography className={classes.text}>{config.privacyText || t('Right Reserved')}</Typography>
    </div>
 );
};
